/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const PERMIT = PropTypes.shape({
    activities: PropTypes.array,
    addresses: PropTypes.array,
    description: PropTypes.shape({
        description: PropTypes.string,
        quota_details: PropTypes.string,
        edu_video_url: PropTypes.string,
        edu_video_title: PropTypes.string,
        video_url: PropTypes.string,
        video_title: PropTypes.string,
    }),
    divisions: PropTypes.object,
    id: PropTypes.string,
    indexed_rules: PropTypes.shape({
        SeasonStart: PropTypes.shape({
            value: PropTypes.number,
        }),
        SeasonEnd: PropTypes.shape({
            value: PropTypes.number,
        }),
        HighUseRegistrationStart: PropTypes.shape({
            value: PropTypes.number,
        }),
        HighUseRegistrationEnd: PropTypes.shape({
            value: PropTypes.number,
        }),
        LotteryResultsAvailable: PropTypes.shape({
            value: PropTypes.number,
        }),
        CancellationDeadline: PropTypes.shape({
            value: PropTypes.number,
        }),
        HighUseSeasonStart: PropTypes.shape({
            value: PropTypes.number,
        }),
        HighUseSeasonEnd: PropTypes.shape({
            value: PropTypes.number,
        }),
        QuotaPerDay: PropTypes.shape({
            value: PropTypes.number,
        }),
    }),
    links: PropTypes.array,
    lotteries: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            is_active: PropTypes.boolean,
        })
    ),
    lottery_fee: PropTypes.string,
    name: PropTypes.string,
    needToKnow: PropTypes.arrayOf(PropTypes.string),
    phone: PropTypes.string,
    recareas: PropTypes.array,
    recreation_fee: PropTypes.string,
    reservation_fee: PropTypes.string,
});
